import { RetentionTableType } from '../../interfaces';
import { freeze } from '@reduxjs/toolkit';

export const MAX_TABLE_HEIGHT = 480;

export const DEFAULT_ROW_HEIGHT = 32;
export const DEFAULT_ROW_HEADER_HEIGHT = 48;

export const DEFAULT_ROW_WIDTH = 120;
export const DEFAULT_FIXED_ROW_WIDTH = 150;

export const COLUMN_OFFSET_PER_TYPE: Record<RetentionTableType, 1 | 2> = freeze(
  {
    // standard retention has 2 fixed columns: interval (5/31/2022) and start identities
    [RetentionTableType.Standard]: 2,
    // over time has 1 fixed column - the return period (Week 2)
    [RetentionTableType.OverTime]: 1,
  },
  true,
);
